import axios from 'axios';

// const serviceUrl = 'http://192.168.0.132';
// const serviceUrl = 'http://192.168.0.8';
// const imgUrl = 'https://navcomm.cn:8998/navbucket/';
const serviceUrl = 'http://1.95.67.4:8000';
export const imgUrl = 'http://1.95.67.4:8888/erpbucket/';

export function axiosPostHttp(url,data = {}){
  let result = axios({
    method: 'post',
    data,
    url: serviceUrl + url,
    headers:{
      
    },
    timeout: 20000
  }).then(res =>{
    if(res.data.code === 200){
      return res.data.data || res.data;
    }else{
      alert(res.data.msg);
      return Promise.reject(res.data);
    }
  }).catch(err =>{
    console.log('err: ',err);
    return Promise.reject(err.response.data);
  })
  return result;
}

export function axiosGetHttp(url, params = {}){
  let result = axios({
    method: 'get',
    params,
    url: serviceUrl + url,
    headers:{
      // 'X-Access-Token': '12acf699001cb21f13d026df25a1d2ed'
      // 'X-Access-Token': window.localStorage.getItem('token')
    },
    timeout: 20000
  }).then(res =>{
    console.log(res);
    if(res.data.code === 200){
      return res.data.data || res.data;
    }else{
      alert(res.data.msg);
      console.log(res.data);
      return Promise.reject(res.data);
    }
  }).catch(err =>{
    console.log('err: ',err);
    // return Promise.reject(err.response.data);
  })
  return result;
}

// 获取url中的参数
export function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
  var context = "";
  if (r != null)
      context = decodeURIComponent(r[2]);
  reg = null;
  r = null;
  return context == null || context == "" || context == "undefined" ? "" : context;
}